var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"copyright"}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"wow bounceIn",staticStyle:{"color":"white"},attrs:{"data-wow-offset":"50","data-wow-delay":"0.3s"}},[_vm._v("深圳卓然软件有限公司 版权所有 粤ICP备2023011215号 ")])])])
}]

export { render, staticRenderFns }